import './index.less'
import 'assets/icons.font'
import 'assets/images/favicon.png'
import 'assets/images/share-image.jpg'

import {Router} from '@codeurs/front'
import m from 'mithril'
import stream from 'mithril/stream'
import {setLanguage} from 'store'
import {
	facebookPixelTracking,
	googleAnalyticsTracking,
	gtmTracking
} from 'util/tracker'
import pages from 'views/pages'

class App extends Router {
	fetch(path: string): Promise<never> {
		return m.request(`${path}?json`, {
			headers: {accept: 'application/json'},
			config: xhr => (this.transport = xhr)
		})
	}

	scroll(hash?: string) {
		if (hash) super.scroll(hash)
	}

	setData(data) {
		super.setData(data)
		pageViewStream({
			path: window.location.pathname + window.location.search,
			title: data.title
		})
	}

	getPageTitle(data) {
		return data.meta_pagetitle
	}

	getView(key, channel) {
		if (key in pages) return pages[key]
		if (channel in pages) return pages[channel]
		throw `No view found for channel ${channel}`
	}

	resolve = (data, route) => {
		const {channel, key} = data
		const comp = this.getView(key, channel)
		setLanguage(data.language)
		return comp.render({
			data,
			route,
			router: this
		})
	}
}

const globals: {[key: string]: string} = window as any
const {__INITIAL_STATE__: initial, __GTM_ID__: gtmId} = globals

const pageViewStream = stream()

const app = new App(initial)
const initialTitle = app.getPageTitle(initial)
const initialPath = window.location.pathname + window.location.search

if (gtmId) {
	gtmTracking(initialTitle, initialPath, pageViewStream)
}

app.mount(document.getElementById('root'))
